import * as types from "../actions/viewManagerTypes";


  const initialState = {
    managers: [],
    loading: false,
    error: null,
  };
  
  const viewManagerReducer = (state = initialState, action) => {
    switch (action.type) {
      case types.FETCH_MANAGER_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case types.FETCH_MANAGER_SUCCESS:
        return {
          ...state,
          loading: false,
          managers: action.payload,
        };
      case types.FETCH_MANAGER_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default viewManagerReducer;
  